import type { RotasDoModulo } from '@/app/rotas';

import { CounterGuaranteesPage, DraftsPage, SignaturesPage } from './GenerationPages';

/** Minutas, CCG e assinaturas. */
export const rotas: RotasDoModulo = {
  menu: {
    '/minutas': DraftsPage,
    '/ccg': CounterGuaranteesPage,
    '/assinaturas': SignaturesPage,
  },
};
